<template>
  <div class="w-full">
    <div :id="id" class="w-full h-100px" v-loading="chartLoading"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'board-chart',
  props: {
    id: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '风险排查完成率',
    },
    value: {
      type: Number,
      default: null,
    },
    total: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      chartLoading: false,
      option: {
        title: {
          text: '',
          textStyle: {
            color: '#fff',
            fontSize: 16,
            fontWeight: 'normal',
          },
          left: 'center',
          bottom: 10,
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['95%', '96%'],
            center: ['50%', '52%'],
            startAngle: 180,
            endAngle: 0,
            color: ['#0471a9', 'transparent'],
            hoverAnimation: false,
            legendHoverLink: false,
            z: 10,
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [100, 100],
          },
          // 中间灰色轴线
          {
            type: 'gauge',
            radius: '90%', // 位置
            center: ['50%', '52%'],
            min: 0,
            max: 200,
            startAngle: 180,
            endAngle: 0,
            axisLine: {
              show: true,
              lineStyle: {
                // 轴线样式
                width: 10, // 宽度
                color: [[1, '#226faf']], // 颜色
              },
            },
            axisTick: {
              // 刻度
              show: false,
            },
            splitLine: {
              // 分割线
              show: false,
            },
            axisLabel: {
              // 刻度标签
              show: false,
            },
            pointer: {
              // 仪表盘指针
              show: false,
            },
            detail: {
              // 仪表盘详情
              show: true,
              fontSize: 16,
              formatter: () => {
                return ''
              },
              offsetCenter: [0, '20%'],
              color: '#9ebbd3',
            },
          },
          // 数据
          {
            type: 'gauge',
            radius: '90%', // 位置
            center: ['50%', '52%'],
            min: 0,
            max: 50,
            startAngle: 180,
            endAngle: 0,
            z: 20,
            axisLine: {
              show: true,
              lineStyle: {
                // 轴线样式
                width: 10, // 宽度
                color: [
                  [
                    0,
                    new echarts.graphic.RadialGradient(1, 0, 1, [
                      {
                        offset: 0,
                        color: '#00dbf1',
                      },

                      {
                        offset: 1,
                        color: '#00dbf1',
                      },
                    ]),
                  ],
                ], // 颜色
              },
            },
            pointer: {
              // 仪表盘指针
              show: true,
              valueAnimation: true,
              length: '80%',
              width: 3, // 指针粗细
              splitNumber: 1,
            },
            data: [],
            axisTick: {
              // 刻度
              show: false,
            },
            splitLine: {
              // 分割线
              show: false,
            },
            axisLabel: {
              // 刻度标签
              show: false,
            },
            detail: {
              // 仪表盘详情
              show: true,
              fontSize: 16,
              zIndex: 50,
              formatter: (value) => {
                return `${value}%`
              },
              offsetCenter: [0, '-10%'],
              color: '#fff',
            },
          },
          {
            name: '',
            type: 'pie',
            radius: ['0%', '40%'],
            center: ['50%', '52%'],
            startAngle: 180,
            endAngle: 0,
            itemStyle: {
              color: (params) => {
                if (params.dataIndex === 0) {
                  return new echarts.graphic.RadialGradient(0.5, 1, 1, [
                    {
                      offset: 1,
                      color: '#00dbf1',
                    },
                    {
                      offset: 0.9,
                      color: 'transparent',
                    },
                    {
                      offset: 0,
                      color: 'transparent',
                    },
                  ])
                }
                return 'transparent'
              },
            },
            hoverAnimation: false,
            legendHoverLink: false,
            z: 30,
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [100, 100],
          },
        ],
      },
    }
  },
  mounted() {
    this.drawCharts()
  },
  methods: {
    // 绘制echarts
    drawCharts() {
      this.myChart = echarts.init(document.getElementById(this.id))

      this.option.title.text = this.title
      this.option.series[2].axisLine.lineStyle.color[0][0] = this.value === 0 ? 1 : this.value / 100
      this.option.series[2].data = [{ value: this.value === 0 ? 100 : this.value }]
      this.myChart.setOption(this.option)

      window.addEventListener('resize', () => {
        this.myChart.resize()
      })
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.myChart.resize()
    })
  },
}
</script>

<style lang="scss" scoped></style>
